import React, { FC } from 'react';

import Maybe from 'graphql/tsutils/Maybe';
import { useIntl } from 'react-intl';

import { ILoyaltyCategoryOption } from 'state/loyalty/types';

import { RewardSelectionLink } from '../reward-selection-link';

import { Content, ContentWrapper, PointsLabel, Title, Wrapper } from './reward-tier.styled';

export const RewardTier: FC<{
  openChangeRewardsModal: () => void;
  selectedTier: Maybe<Omit<ILoyaltyCategoryOption, 'description'>>;
}> = ({ openChangeRewardsModal, selectedTier, ...props }) => {
  const { formatMessage } = useIntl();

  if (!selectedTier) {
    return null;
  }

  return (
    <Wrapper {...props}>
      <Title>{formatMessage({ id: 'rewardsManagementChoosenLevel' })}</Title>
      <ContentWrapper>
        <Content data-testid="reward-tier-title">{selectedTier.name.locale}</Content>
        <PointsLabel data-testid="reward-tier-points">
          {formatMessage({ id: 'rewardsManagementPoints' }, { points: selectedTier.points })}
        </PointsLabel>
      </ContentWrapper>
      <RewardSelectionLink onClick={openChangeRewardsModal} />
    </Wrapper>
  );
};
